'use strict';

/**
 * Resolves a props object from options and config.
 * Order of precendence is:
 *   1. Runtime result of options.getComputedProps fn (invoked with config)
 *   2. Vizia Component options (config.scene.options root props)
 *   3. Vizia Slide options (config.scene root props)
 *   4. Vizia Folder options (config root props)
 *   5. Factory options (options root props)
 */

const noop = () => {};

function omitProp(obj = {}, keys) {
    return Object.keys(obj)
        .filter((key) => !keys.includes(key))
        .reduce((memo, key) => Object.assign(memo, {[key]: obj[key]}), {});
}

function resolveProps(config, options = {}) {
    const {getComputedProps = noop} = options;
    const factoryProps = omitProp(options, 'getComputedProps');
    const folderProps = omitProp(config, 'scene');
    const slideProps = omitProp((config && config.scene), 'options');
    const componentProps = config && config.scene && config.scene.options;
    const computedProps = getComputedProps(config);

    return Object.assign({},
        factoryProps,
        folderProps,
        slideProps,
        componentProps,
        computedProps
    );
}

module.exports = resolveProps;
